<template>
    <v-layout row wrap>
        <v-flex grow>
            <v-layout row wrap>
                <template v-if="taxes==='19'">
                    <v-flex xs12 md6 lg3>
                        <s-text-field
                                v-model="misc.description"
                                :label="__('labels.misc_expense_description')"
                                :rules="rules.description">
                        </s-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg3>
                        <s-price-field
                                v-model="misc.brutto"
                                :label="__('labels.misc_expense_brutto_sum')"
                                @input="updateNetto"
                                :rules="rules.brutto"
                        >
                        </s-price-field>
                    </v-flex>
                    <v-flex xs12 md6 lg3>
                        <v-radio-group v-model="misc.taxes" :rules="rules.taxes" row @change="updateNetto">
                            <template v-slot:label>
                                <div>{{__('labels.misc_expense_taxes')}}</div>
                            </template>
                            <v-radio
                                    label="0 %"
                                    value="0"
                            ></v-radio>
                            <v-radio
                                    :label="taxReduction ? '5 %' : '7 %'"
                                    :value="taxReduction ? 5 : 7"
                            ></v-radio>
                            <v-radio
                                    :label="taxReduction ? '16 %' : '19 %'"
                                    :value="taxReduction ? 16 : 19"
                            ></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs12 md6 lg3>
                        <s-price-field
                                :value="misc.netto"
                                :label="__('labels.misc_expense_netto_sum')"
                                @input="calculateSum"
                                readonly
                                disabled
                        >
                        </s-price-field>
                    </v-flex>
                </template>
                <template v-else>
                    <v-flex xs12 md6>
                        <s-text-field
                                v-model="misc.description"
                                :label="__('labels.misc_expense_description')"
                                :rules="rules.description"
                        >
                        </s-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <s-price-field
                                v-model="misc.brutto"
                                :label="__('labels.misc_expense_sum')"
                                :rules="rules.brutto"
                                @input="calculateSum"
                        >
                        </s-price-field>
                    </v-flex>
                </template>
            </v-layout>
        </v-flex>
        <v-flex shrink>
            <v-btn fab icon color="primary" small @click="removeMiscTravelingExpense(index)">
                <v-icon>delete_outline</v-icon>
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "MiscTravelingExpenseField",
        props: {
            label: String,
            misc: Object,
            index: [Number, String]
        },
        computed: {
            ...mapState('form', [
                'taxes',
                "performanceDates",
            ]),
            taxReduction() {
                let flattenedDates = _.flatten(_.map(this.performanceDates, 'dates'))
                let firstDate = flattenedDates[0]
                return this.$moment(firstDate).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01'))
            }
        },
        data() {
            return {
                rules: this.$validation.create({
                        description: ['required'],
                        brutto: ['required'],
                        taxes: ['required'],
                    }
                )
            }
        },
        methods: {
            ...mapActions('form', [
                'removeMiscTravelingExpense',
                'calculateSum'
            ]),
            updateNetto() {
                this.misc.netto = Math.round(this.misc.brutto / (1 + this.misc.taxes / 100));
                this.calculateSum();
            }
        },
        watch: {
            taxes(value) {
                this.updateNetto();
            }
        }
    }
</script>

<style scoped>
    >>> .v-input--radio-group__input > .v-label {
        left: -25px !important;
        right: auto !important;
        position: absolute !important;
        max-width: 133%;
        transform: translateY(-18px) scale(.75);
    }
</style>